import React, { useState } from 'react';
import {showModal} from 'react-redux-modal-provider';
import Modal from 'react-bootstrap/esm/Modal';
import { Button, ComentarioNotifyCard, TicketNotifyCard } from '@app/components/index';
import ModalNotificationTickets from '@app/modals/notifications/ModalNotificationTickets';
import ModalNotificationComentario from '@app/modals/notifications/ModalNotificationComentario';
import Dropdown from 'react-bootstrap/Dropdown';
import LogService from '@app/services/log.service';


function ModalNotificationsAlls({show, hideModal,ticketNotify,comentarioNotify}) {
    const handleClose = () => hideModal();
    const [viewData, setviewData] = useState('ticket')

    const onOpenModalTicketNotify = () =>{
        showModal(ModalNotificationTickets)
    }
    const onOpenModalComentarioNotify = () =>{
        showModal(ModalNotificationComentario)
    }

    return (
        <Modal show={show} backdrop="static" size='md' onHide={handleClose}>
            <Modal.Header closeButton style={{borderBottom: 'none', paddingBottom: 0}}>
                <div style={{width: '100%'}}>
                    <p className="text-muted mb-2" style={{fontSize: '11px', letterSpacing: '1px', textTransform: 'uppercase', fontWeight: 600}}>
                        <i className="fas fa-bell mr-1" />
                        Notificaciones
                    </p>
                    <div className="d-flex align-items-center" style={{gap: '8px'}}>
                        <button
                            type="button"
                            onClick={() => setviewData('ticket')}
                            style={{
                                flex: 1,
                                padding: '8px 12px',
                                borderRadius: '8px',
                                border: viewData === 'ticket' ? 'none' : '1px solid #dee2e6',
                                background: viewData === 'ticket' ? '#dc3545' : '#fff',
                                color: viewData === 'ticket' ? '#fff' : '#555',
                                fontWeight: 600,
                                fontSize: '13px',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                            }}
                        >
                            <i className="fas fa-ticket-alt" />
                            TICKETS
                            {ticketNotify?.count > 0 && (
                                <span
                                    style={{
                                        background: viewData === 'ticket' ? 'rgba(255,255,255,0.3)' : '#dc3545',
                                        color: '#fff',
                                        borderRadius: '12px',
                                        padding: '1px 8px',
                                        fontSize: '12px',
                                        fontWeight: 700,
                                    }}
                                >
                                    {ticketNotify.count}
                                </span>
                            )}
                        </button>
                        <button
                            type="button"
                            onClick={() => setviewData('comentarios')}
                            style={{
                                flex: 1,
                                padding: '8px 12px',
                                borderRadius: '8px',
                                border: viewData === 'comentarios' ? 'none' : '1px solid #dee2e6',
                                background: viewData === 'comentarios' ? '#dc3545' : '#fff',
                                color: viewData === 'comentarios' ? '#fff' : '#555',
                                fontWeight: 600,
                                fontSize: '13px',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                            }}
                        >
                            <i className="fas fa-comment-alt" />
                            COMENTARIOS
                            {comentarioNotify?.count > 0 && (
                                <span
                                    style={{
                                        background: viewData === 'comentarios' ? 'rgba(255,255,255,0.3)' : '#dc3545',
                                        color: '#fff',
                                        borderRadius: '12px',
                                        padding: '1px 8px',
                                        fontSize: '12px',
                                        fontWeight: 700,
                                    }}
                                >
                                    {comentarioNotify.count}
                                </span>
                            )}
                        </button>
                        <Dropdown size="sm">
                            <Dropdown.Toggle
                                variant="light"
                                id="dropdown-basic"
                                style={{borderRadius: '8px', padding: '8px 10px', border: '1px solid #dee2e6', color: '#666', background: '#f8f9fa'}}
                            />
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => { LogService.ticketNotifyViewAll(); handleClose(); }}>
                                    <i className="fas fa-check mr-2 text-muted" />
                                    Marcar tickets como leídos
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => { LogService.comentarioNotifyViewAll(); handleClose(); }}>
                                    <i className="fas fa-check mr-2 text-muted" />
                                    Marcar comentarios como leídos
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={() => { LogService.notifyViewAll(); handleClose(); }}>
                                    <i className="fas fa-check-double mr-2 text-success" />
                                    Marcar todo como leído
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </Modal.Header>
            <div className='col-12 bg-white'>
                { viewData === 'ticket' &&(
                        ticketNotify?.content?.length > 0 ? (
                        <>
                            {ticketNotify?.content?.map((ment)=>{
                                return(
                                    <div key={ment?.id_tkntf} className='col-12 m-1'>
                                        <TicketNotifyCard item={ment} isModal toggleDropdown={()=>handleClose()} />
                                        <div className="dropdown-divider mt-1 mb-1" />
                                    </div>
                                )
                            })}
                            {ticketNotify?.totalPages > 1 && (
                                <div
                                    className='dropdown-item dropdown-footer bg-blue cursor-pointer'
                                    aria-hidden="true"
                                    onClick={()=> { handleClose(); onOpenModalTicketNotify();}}
                                >
                                    Ver todas las notificaciones
                                </div>
                            )}
                        </>
                    ):(
                        <div className='p-3 alert alert-light mt-2 text-center'>
                            Aún no registra una actividad.
                        </div>
                    )
                )}
                { viewData === 'comentarios' &&(
                        comentarioNotify?.content?.length > 0 ? (
                        <>
                            {comentarioNotify?.content?.map((ment)=>{
                                return(
                                    <div key={ment?.id_comntf} className='col-12 m-1'>
                                        <ComentarioNotifyCard item={ment} isModal toggleDropdown={()=>handleClose()} />
                                        <div className="dropdown-divider mt-1 mb-1" />
                                    </div>
                                )
                            })}
                            {comentarioNotify?.totalPages > 1 && (
                                <div
                                    className='dropdown-item dropdown-footer bg-blue cursor-pointer'
                                    aria-hidden="true"
                                    onClick={()=> { handleClose(); onOpenModalComentarioNotify();}}
                                >
                                    Ver todas las notificaciones
                                </div>
                            )}
                        </>
                    ):(
                        <div className='p-3 alert alert-light mt-2 text-center'>
                            Aún no registra una actividad.
                        </div>
                    )
                )}
            </div>
            <Modal.Footer>
                <Button onClick={()=>handleClose()} theme='default'>
                    CERRAR
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
export default ModalNotificationsAlls;
